export const avisosPrivacidadNormalize = (x) => ({
    idAviso: x.idAviso ?? x.IdAviso ?? 0,
    avisoContenido: x.avisoContenido ?? x.AvisoContenido ?? '',
    idEmpresa: x.idEmpresa ?? x.IdEmpresa ?? 0,
    nombreEmpresa: x.nombreEmpresa ?? x.NombreEmpresa ?? '',
    fechaCaducidad: x.fechaCaducidad ?? x.FechaCaducidad ?? null,
    activo: x.activo ?? x.Activo ?? true,
});
